const siliconAnodeData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133792/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_a731f0df-0943-4fa5-8b0c-e234761ddcf5_eu2pit.png',
  forecastBrochureFile: {
    file_name: 'Silicon Anode Forecast Brochure.pdf',
    category: 'public-documents',
    EnvKey: 'forecastBrochureSiliconAnodeFilePdfID',
  },
  banner: {
    title:
      'Our service provides a comprehensive overview of the silicon anode landscape including:',
    descriptions: [
      {
        items: [
          '<strong>Silicon Today:</strong> Outlining progress to date and challenges to come',
          '<strong>Commercial Landscape:</strong> Identifying critical barriers to commercialisation and understanding market opportunities',
          '<strong>Categorising Silicon Active Materials:</strong> By capacity, by morphology, and by feedstock',
          '<strong>Forecasting Industry Growth:</strong> Low, base and high-case supply and demand scenarios',
          '<strong>Quarterly News:</strong> Your one-stop for major announcements, market trends, and industry analysis',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1708704900/assets/forecasts/silicon-anode/sustainable_opencast_mine_big_sky_shades_of_yellow_and_white_lo-fi_illustration_--ar_3_2_-_abcfpe.png',
        alt: 'Silicon Anode Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1708704989/assets/forecasts/silicon-anode/Mask_group_gg6n2d.png',
        alt: 'Silicon Anode Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1708705068/assets/forecasts/silicon-anode/Mask_group_2_dliyh6.png',
        alt: 'Silicon Anode Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_600,c_fill/v1708705079/assets/forecasts/silicon-anode/Mask_group_second_section_eiwycc.png',
      title:
        'You will receive access to the data, assumptions, and analyst insights that underpin Benchmark’s silicon Anode forecast.',
      descriptions: [
        {
          subtitle:
            'We present a “Silicon Anode” forecast which tracks the expansion plans of silicon AAM and anode producers on a facility-by-facility basis:',
          items: [
            '<strong>Bottom-up Analysis:</strong> Full access to facility and company commercial roadmaps.',
            '<strong>Robust scenarios:</strong> View the raw data and understand Benchmark’s low-, base- and high-case supply and demand scenario analysis out to 2040.',
            '<strong>Clear assumptions:</strong> Review and discuss Benchmark’s assumptions with unrestricted access to analysts.',
          ],
        },
        {
          subtitle:
            'Comprehensive PDF of contextual information as a tool to demystify the silicon industry:',
          items: [
            'An introduction to silicon active materials and technologies',
            'Silicon in battery applications',
            'Categorising silicon materials',
            'Supply chain insights',
            'Commercial progress and prospective applications',
            'Manufacturing',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_1000,c_fill/v1708705083/assets/forecasts/silicon-anode/Mask_group_third_section_mwprxy.png',
      title:
        'With a subscription to Benchmark’s Silicon Anode Forecast you will get:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible content:</strong> Updated on a quarterly basis',
            '<strong>Excel forecast file:</strong> Map the silicon market on a facility-by-facility basis and understand Benchmark’s supply and demand scenarios',
            '<strong>Deep-dive content:</strong> Each quarter will contain detailed analysis of a critical topic of the silicon industry – the first release focuses on silane gas',
            '<strong>Context is king:</strong> Supporting PDF deck with >100 slides of contextual information',
            '<strong>Analyst access:</strong> Unrestricted support for your subscription and discussions about market dynamics/developments',
          ],
        },
      ],
    },
  },
}

export default siliconAnodeData
